import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const QualityCommitment = () => {
  const qualityPillars = [
  {
    icon: "Leaf",
    title: "Fresh Ingredients",
    description: "We source fresh vegetables, meats, and spices daily from trusted local farmers and suppliers. No frozen or processed ingredients.",
    image: "https://images.unsplash.com/photo-1619369575639-906f8b35107f",
    imageAlt: "Close-up of fresh colorful vegetables including red tomatoes, green peppers, and leafy greens arranged on wooden cutting board in bright kitchen with morning sunlight"
  },
  {
    icon: "ShieldCheck",
    title: "Food Safety Standards",
    description: "Certified by South Sudan Food Safety Authority. Our kitchen follows strict hygiene protocols and regular health inspections.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16da815f1-1766248702712.png",
    imageAlt: "Professional chef in white uniform and hairnet carefully inspecting food preparation area with clipboard, wearing gloves in spotless stainless steel commercial kitchen"
  },
  {
    icon: "Users",
    title: "Trained Staff",
    description: "Every team member undergoes comprehensive training in food preparation, safety, and customer service excellence.",
    image: "https://i.ibb.co/YTJxxQDh/staff.jpg",
    imageAlt: "Group of diverse kitchen staff in matching red and white uniforms attending training session, taking notes while head chef demonstrates proper food handling techniques"
  },
  {
    icon: "Clock",
    title: "Made to Order",
    description: "Each meal is prepared fresh when you order. We never pre-cook or reheat food to ensure maximum flavor and quality.",
    image: "https://i.ibb.co/jkdWF6Kg/order.jpg",
    imageAlt: "Chef's hands skillfully preparing fresh chapati on hot griddle with steam rising, showing traditional cooking technique in busy restaurant kitchen with flames visible"
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Award" size={20} color="var(--color-primary)" />
            <span className="text-primary font-semibold text-sm md:text-base">Quality Commitment</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Our Promise to You
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Quality isn't just a goal—it's our foundation. Here's how we ensure every meal meets our high standards.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {qualityPillars?.map((pillar, index) =>
          <div
            key={index}
            className="bg-card rounded-xl overflow-hidden shadow-lg border border-border hover:shadow-xl transition-shadow duration-300">

              <div className="relative aspect-[16/9] overflow-hidden">
                <Image
                src={pillar?.image}
                alt={pillar?.imageAlt}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 left-4 w-12 h-12 md:w-14 md:h-14 bg-primary rounded-full flex items-center justify-center shadow-lg">
                  <Icon name={pillar?.icon} size={24} color="#FFFFFF" />
                </div>
              </div>
              
              <div className="p-4 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 md:mb-3">
                  {pillar?.title}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {pillar?.description}
                </p>
              </div>
            </div>
          )}
        </div>
        
        <div className="mt-8 md:mt-12 bg-primary/5 border border-primary/20 rounded-xl p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="BadgeCheck" size={32} color="#FFFFFF" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">
                Certified & Trusted
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                Chapati Plus is officially certified by the South Sudan Food Safety Authority and regularly inspected to maintain the highest standards of food preparation, storage, and service. Our certification number: SSFSA-2024-JB-0156
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default QualityCommitment;